module.exports = "../../../../platform/assets/pageMainIcon/ig-business-setting-6.svg";